import React from 'react';
/**審核未過會看到此區塊反應快只會出現0.5秒反應慢會有1-2秒看到文字 */
class customerRedirect extends React.Component{
    constructor( props ){
        super(props);
        this.state = { ...props };
      }
      componentDidMount(){
        const cid = this.props.match.params.cid;
        window.location = "https://www.1111.com.tw/corp/"+cid;
        const elm= document.getElementById("PageLoader");
        if(elm){
            elm.innerHTML=this.state.RedirMsg;
        }
      }
    
      render(){            
        return (<section>{this.props.RedirMsg}..Redirecting...</section>);
      }

}

export default customerRedirect;